"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Video = exports.ResourceMaterial = exports.moduleEntity = exports.Company = exports.Course = exports.GithubAssignmentQuestion = exports.ConceptualQuestion = exports.CodingQuestion = exports.Tag = exports.Unit = exports.JobSincerity = exports.CallbackRequestLead = exports.PotentialReferral = exports.SalesLeads = exports.UserReportCard = exports.UserCourseEnrollment = exports.StudentPersonalDetails = exports.Users = exports.entities = void 0;
__exportStar(require("./enums/student_personal_details.js"), exports);
__exportStar(require("./enums/course.js"), exports);
__exportStar(require("./dto/profileUpdate.js"), exports);
var Users_js_1 = require("./entities/Users.js");
Object.defineProperty(exports, "Users", {
  enumerable: true,
  get: function get() {
    return Users_js_1.Users;
  }
});
var Course_js_1 = require("./entities/Course.js");
Object.defineProperty(exports, "Course", {
  enumerable: true,
  get: function get() {
    return Course_js_1.Course;
  }
});
var StudentPersonalDetails_js_1 = require("./entities/StudentPersonalDetails.js");
Object.defineProperty(exports, "StudentPersonalDetails", {
  enumerable: true,
  get: function get() {
    return StudentPersonalDetails_js_1.StudentPersonalDetails;
  }
});
var UserCourseEnrollment_js_1 = require("./entities/UserCourseEnrollment.js");
Object.defineProperty(exports, "UserCourseEnrollment", {
  enumerable: true,
  get: function get() {
    return UserCourseEnrollment_js_1.UserCourseEnrollment;
  }
});
var UserReportCard_js_1 = require("./entities/UserReportCard.js");
Object.defineProperty(exports, "UserReportCard", {
  enumerable: true,
  get: function get() {
    return UserReportCard_js_1.UserReportCard;
  }
});
var SalesLeads_js_1 = require("./entities/SalesLeads.js");
Object.defineProperty(exports, "SalesLeads", {
  enumerable: true,
  get: function get() {
    return SalesLeads_js_1.SalesLeads;
  }
});
var JobSincerity_js_1 = require("./entities/JobSincerity.js");
Object.defineProperty(exports, "JobSincerity", {
  enumerable: true,
  get: function get() {
    return JobSincerity_js_1.JobSincerity;
  }
});
var Units_js_1 = require("./entities/Units.js");
Object.defineProperty(exports, "Unit", {
  enumerable: true,
  get: function get() {
    return Units_js_1.Unit;
  }
});
var PotentialReferral_js_1 = require("./entities/PotentialReferral.js");
Object.defineProperty(exports, "PotentialReferral", {
  enumerable: true,
  get: function get() {
    return PotentialReferral_js_1.PotentialReferral;
  }
});
var CallbackRequestLead_js_1 = require("./entities/CallbackRequestLead.js");
Object.defineProperty(exports, "CallbackRequestLead", {
  enumerable: true,
  get: function get() {
    return CallbackRequestLead_js_1.CallbackRequestLead;
  }
});
var Tag_js_1 = require("./entities/Tag.js");
Object.defineProperty(exports, "Tag", {
  enumerable: true,
  get: function get() {
    return Tag_js_1.Tag;
  }
});
var CodingQuestion_js_1 = require("./entities/CodingQuestion.js");
Object.defineProperty(exports, "CodingQuestion", {
  enumerable: true,
  get: function get() {
    return CodingQuestion_js_1.CodingQuestion;
  }
});
var ConceptualQuestion_js_1 = require("./entities/ConceptualQuestion.js");
Object.defineProperty(exports, "ConceptualQuestion", {
  enumerable: true,
  get: function get() {
    return ConceptualQuestion_js_1.ConceptualQuestion;
  }
});
var Company_js_1 = require("./entities/Company.js");
Object.defineProperty(exports, "Company", {
  enumerable: true,
  get: function get() {
    return Company_js_1.Company;
  }
});
var GithubAssignmentQuestion_js_1 = require("./entities/GithubAssignmentQuestion.js");
Object.defineProperty(exports, "GithubAssignmentQuestion", {
  enumerable: true,
  get: function get() {
    return GithubAssignmentQuestion_js_1.GithubAssignmentQuestion;
  }
});
var Module_js_1 = require("./entities/Module.js");
Object.defineProperty(exports, "moduleEntity", {
  enumerable: true,
  get: function get() {
    return Module_js_1.Module;
  }
});
var ResourceMaterial_js_1 = require("./entities/ResourceMaterial.js");
Object.defineProperty(exports, "ResourceMaterial", {
  enumerable: true,
  get: function get() {
    return ResourceMaterial_js_1.ResourceMaterial;
  }
});
var Video_js_1 = require("./entities/Video.js");
Object.defineProperty(exports, "Video", {
  enumerable: true,
  get: function get() {
    return Video_js_1.Video;
  }
});
var entities = {
  Users: Users_js_1.Users,
  StudentPersonalDetails: StudentPersonalDetails_js_1.StudentPersonalDetails,
  UserCourseEnrollment: UserCourseEnrollment_js_1.UserCourseEnrollment,
  UserReportCard: UserReportCard_js_1.UserReportCard,
  SalesLeads: SalesLeads_js_1.SalesLeads,
  PotentialReferral: PotentialReferral_js_1.PotentialReferral,
  CallbackRequestLead: CallbackRequestLead_js_1.CallbackRequestLead,
  JobSincerity: JobSincerity_js_1.JobSincerity,
  Unit: Units_js_1.Unit,
  Tag: Tag_js_1.Tag,
  CodingQuestion: CodingQuestion_js_1.CodingQuestion,
  ConceptualQuestion: ConceptualQuestion_js_1.ConceptualQuestion,
  GithubAssignmentQuestion: GithubAssignmentQuestion_js_1.GithubAssignmentQuestion,
  Course: Course_js_1.Course,
  Company: Company_js_1.Company,
  moduleEntity: Module_js_1.Module,
  ResourceMaterial: ResourceMaterial_js_1.ResourceMaterial,
  Video: Video_js_1.Video
};
exports.entities = entities;